import styled from 'styled-components';
import { Table } from 'shared/components';

export const StyledTable = styled(Table)``;
export default StyledTable;
